'use strict';

// =================================================================================================================
// SWIPER
// =================================================================================================================
const newsSwiperEl = document.querySelector(".js-news-swiper");
if (newsSwiperEl && typeof Swiper !== "undefined") {
  const slidesCount = newsSwiperEl.querySelectorAll(".swiper-slide").length;
  const shouldLoop = slidesCount > 1;
  new Swiper(".js-news-swiper", {
    loop: shouldLoop,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: 'auto',
  });
}


// =================================================================================================================
// フェードインアニメーション
// =================================================================================================================
document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(".fade-in");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("show");
        observer.unobserve(entry.target); // 一度だけ発火
      }
    });
  });

  targets.forEach((target) => observer.observe(target));
});
